module.exports = __webpack_public_path__ + "img/recommendEmpty.888cf2cd.png";